import { render, staticRenderFns } from "./TwilioWarning.vue?vue&type=template&id=24f1e87f&scoped=true&"
import script from "./TwilioWarning.vue?vue&type=script&lang=js&"
export * from "./TwilioWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1e87f",
  null
  
)

export default component.exports